import { styled, theme } from 'ui/theme';

export const Progress = {
  Component: styled.div`
    width: 100%;
    padding: 0 ${theme.space[4]};
    margin: ${theme.space[2]} 0 0;
  `,

  Info: styled.span`
    align-items: center;
    display: flex;
    font-size: ${theme.fontSizes.md};
    margin-bottom: ${theme.space[3]};
  `,
};
